<ion-row *ngIf="!isBookingCode">
  <ion-col size="12">
    <ion-button class="action-button-fill button-color-transparent" (click)="switchLoadBookingCode()">
      <span class="button-font-size-s">Check booking</span>
      <icon-wrapper slot="start" [icon]="appIconsStandard.clipboard" class="slot-icon-padding">
      </icon-wrapper>
    </ion-button>
  </ion-col>
</ion-row>

<div *ngIf="isBookingCode" class="padding-s text-left">

  <ion-row>
    <ion-col class="padding-s center-text">
      <span class="center-text info-text-mlg bold text-color-primary">Booking
        Checker</span>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="bookingReferenceInfo" class="center-items">
    <ion-col size="2">
      <img [src]="bookingReferenceInfoIcon" class="img-xxs" />
    </ion-col>
    <ion-col size="10">
      <div linkInterceptor [innerHTML]="bookingReferenceInfo" class="info-text-m description-frame text-color-primary">
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col class="padding-s center-text">
      <edit-options *ngIf="settings" [(prop)]="bookingProvider" [options]="bookingProviderOTAs" placeholder="undefined"
        (optionChange)="selectProvider()">
        <inner-content>Booking Platform</inner-content>
      </edit-options>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col class="padding-s center-text">
      <span class="center-text info-text-mlg bold text-color-primary">Booking
        Reference</span>
    </ion-col>
  </ion-row>

  <ion-row class="center-items">
    <ion-col size="4" *ngIf="bookingPrefix">
      <ion-item class="transparent">
        <ion-input [(ngModel)]="bookingPrefix" ngDefaultControl type="text" class="text-color info-text-m"
          [disabled]="true" placeholder="">
        </ion-input>
      </ion-item>
    </ion-col>
    <ion-col [size]="bookingPrefix ? 8 : 12">
      <ion-item class="transparent">
        <!-- <ion-label position="stacked" class="text-color info-text-m">Booking
                  Reference</ion-label> -->
        <ion-input [(ngModel)]="bookingReference" ngDefaultControl type="text" class="text-color info-text-m"
          [disabled]="false" placeholder="Enter booking reference code">
        </ion-input>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <ion-button class="action-button-fill button-color-alternate" (click)="loadBookingInstructionsForReference()">
        <span class="button-font-size-s">Check booking</span>
        <icon-wrapper slot="start" [icon]="appIconsStandard.clipboard" class="slot-icon-padding">
        </icon-wrapper>
      </ion-button>
    </ion-col>
  </ion-row>
</div>